import { useRouter } from "next/router";
import {   useState } from "react";

const ElectionSchedule = () => {
  const router = useRouter();
  const isBH = router?.asPath?.includes("/bihar");
  const [phase1, setPhase1] = useState(true);
  const [phase2, setPhase2] = useState(true);
  const phaseObj = {
    phase1: [
      {
        phase: "फेज 1",
        constituency: "अगिआंव (एससी)",
        key: "Aghiaon (SC)",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "आलमनगर",
        key: "Alamnagar",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "अलौली (एससी)",
        key: "Alauli (SC)",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "अलीनगर",
        key: "Alinagar",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "अमनौर",
        key: "Amanour",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "आरा",
        key: "Ara",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "अस्थावां",
        key: "Asthawan",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "औराई",
        key: "Aurai",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बछवाड़ा",
        key: "Bachhwara",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बहादुरपुर",
        key: "Bahadurpur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बैकुंठपुर",
        key: "Baikunthpur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बखरी (एससी)",
        key: "Bakhri (SC)",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बख्तियारपुर",
        key: "Bakhtiarpur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बनियापुर",
        key: "Baniapur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बांकीपुर",
        key: "Bankipur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बरौली",
        key: "Barauli",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बरबीघा",
        key: "Barbigha",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बाढ़",
        key: "Barh",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "ब्रहमपुर (ब्रह्मपुर)",
        key: "Brahmpur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बड़हरा",
        key: "Barhara",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बड़हरिया",
        key: "Barharia",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बरूराज",
        key: "Baruraj",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बेगूसराय",
        key: "Begusarai",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बेलदौर",
        key: "Beldour",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बेनीपुर",
        key: "Benipur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "भोरे (एससी)",
        key: "Bhore (SC)",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बिभूतिपुर",
        key: "Bibhutipur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बिहारीगंज",
        key: "Bihariganj",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बिहारशरीफ",
        key: "Bihar Sharif",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बिक्रम",
        key: "Bikram",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बोचहां (एससी)",
        key: "Bochaha (SC)",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "बक्सर",
        key: "Buxar",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "छपरा",
        key: "Chhapra",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "चेरिया बरियारपुर",
        key: "Cheria Bariarpur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "दानापुर",
        key: "Danapur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "दरौली (एससी)",
        key: "Darauli (SC)",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "दरौंदा",
        key: "Daraunda",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "दरभंगा",
        key: "Darbhanga",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "दरभंगा ग्रामीण",
        key: "Darbhanga Rural",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "दीघा",
        key: "Digha",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "डुमरांव",
        key: "Dumraon",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "एकमा",
        key: "Ekma",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "फतुहा",
        key: "Fatuha",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "गायघाट",
        key: "Gaighat",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "गरखा (एससी)",
        key: "Garkha (SC)",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "गोपालगंज",
        key: "Gopalganj",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "गौरा बौरम",
        key: "Gaura Bauram",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "गोरियाकोठी",
        key: "Goriakothi",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "हाजीपुर",
        key: "Hajipur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "हरनौत",
        key: "Harnaut",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "हसनपुर",
        key: "Hasanpur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "हथुआ",
        key: "Hathua",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "हायाघाट",
        key: "Hayaghat",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "हिलसा",
        key: "Hilsa",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "इस्लामपुर",
        key: "Islampur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "जगदीशपुर",
        key: "Jagdishpur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "जाले",
        key: "Jale",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "जमालपुर",
        key: "Jamalpur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "कल्याणपुर (एससी)",
        key: "Kalyanpur (SC)",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "कांटी",
        key: "Kanti",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "केवटी",
        key: "Kewti",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "खगड़िया",
        key: "Khagaria",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "कुचायकोट",
        key: "Kuchaykot",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "कुम्हरार",
        key: "Kumhrar",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "कुढ़नी",
        key: "Kurhani",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "कुशेश्वर स्थान (एससी)",
        key: "Kusheshwar Asthan (SC)",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "लखीसराय",
        key: "Lakhisarai",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "लालगंज",
        key: "Lalganj",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "मधेपुरा",
        key: "Madhepura",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "महाराजगंज",
        key: "Maharajganj",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "महिषी",
        key: "Mahishi",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "महुआ",
        key: "Mahua",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "मनेर",
        key: "Maner",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "महनार",
        key: "Mahnar",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "मांझी",
        key: "Manjhi",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "मढ़ौरा",
        key: "Madhoura",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "मसौढ़ी (एससी)",
        key: "Masaudi (SC)",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "मटिहानी",
        key: "Matihani",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "मीनापुर",
        key: "Minapur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "मोहिउद्दीननगर",
        key: "Mohiuddinagar",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "मोकामा",
        key: "Mokama",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "मोरवा",
        key: "Morwa",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "मुंगेर",
        key: "Munger",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "मुजफ्फरपुर",
        key: "Muzaffarpur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "नालंदा",
        key: "Nalanda",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "पालीगंज",
        key: "Paliganj",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "परबत्ता",
        key: "Parbatta",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "पारू",
        key: "Paroo",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "परसा",
        key: "Parsa",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "पातेपुर (एससी)",
        key: "Patepur (SC)",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "पटना साहिब",
        key: "Patna Sahib",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "फुलवारी",
        key: "Phulwari",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "राघोपुर",
        key: "Raghopur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "रघुनाथपुर",
        key: "Raghunathpur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "राजा पाकर (एससी)",
        key: "Raja Pakar (SC)",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "राजगीर (एससी)",
        key: "Rajgir (SC)",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "राजपुर (एससी)",
        key: "Rajpur (SC)",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "रोसड़ा (एससी)",
        key: "Rosra (SC)",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "सहरसा",
        key: "Saharsa",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "साहेबगंज",
        key: "Sahebganj",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "साहेबपुर कमाल",
        key: "Sahebpur Kamal",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "सकरा (एससी)",
        key: "Sakra (SC)",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "समस्तीपुर",
        key: "Samastipur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "संदेश",
        key: "Sandesh",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "सरायरंजन",
        key: "Sarai Ranjan",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "शाहपुर",
        key: "Shahpur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "शेखपुरा",
        key: "Sheikhpura",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "सिमरी बख्तियारपुर",
        key: "Simri Bakhtiyarpur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "सिंहेश्वर (एससी)",
        key: "Singheshwar (SC)",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "सिवान",
        key: "Siwan",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "सोनबरसा (एससी)",
        key: "Sonbarsa (SC)",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "सोनपुर",
        key: "Sonepur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "सूर्यगढ़ा",
        key: "Suryagarha",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "तरैया",
        key: "Taria",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "जीरादेई",
        key: "Ziradei",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "तारापुर",
        key: "Tarapur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "तरारी",
        key: "Tarari",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "तेघरा",
        key: "Teghra",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "उजियारपुर",
        key: "Ujiarpur",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "वैशाली",
        key: "Vaishali",
        state: "बिहार",
        date: "06, Nov 2025",
      },
      {
        phase: "फेज 1",
        constituency: "वारिसनगर",
        key: "Warisnagar",
        state: "बिहार",
        date: "06, Nov 2025",
      },
    ],

    phase2: [
      {
        phase: "फेज 2",
        constituency: "अमरपुर",
        key: "Amarpur",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "अमौर",
        key: "Amour",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "अररिया",
        key: "Araria",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "अरवल",
        key: "Arwal",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "अतरी",
        key: "Atri",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "औरंगाबाद",
        key: "Aurangabad",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बाबूबरही",
        key: "Babubarhi",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बगहा",
        key: "Bagaha",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बहादुरगंज",
        key: "Bahadurganj",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बैसी",
        key: "Baisi",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बाजपट्टी",
        key: "Bajpatti",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बलरामपुर",
        key: "Balrampur",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बांका",
        key: "Banka",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बनमनखी (एससी)",
        key: "Banmankhi (SC)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बाराचट्टी (एससी)",
        key: "Barachatti (SC)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बरारी",
        key: "Barari",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बथनाहा (एससी)",
        key: "Bathnaha (SC)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बेलागंज",
        key: "Belaganj",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बेलहर",
        key: "Belhar",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बेलसंड",
        key: "Belsand",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बेनीपट्टी",
        key: "Benipatti",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बेतिया",
        key: "Bettiah",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "भभुआ",
        key: "Bhabhua",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "भागलपुर",
        key: "Bhagalpur",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बिहपुर",
        key: "Bihpur",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बिस्फी",
        key: "Bisfi",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "बोधगया (एससी)",
        key: "Bodh Gaya (SC)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "चैनपुर",
        key: "Chainpur",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "चकाई",
        key: "Chakai",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "चनपटिया",
        key: "Chanpatia",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "चेनारी",
        key: "Chenari",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "छातापुर",
        key: "Chhatapur",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "चिरैया",
        key: "Chiraia",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "डेहरी",
        key: "Dehri",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "ढाका",
        key: "Dhaka",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "धमदाहा",
        key: "Dhamdaha",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "धोरैया (एससी)",
        key: "Dhoraiya (SC)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "दिनारा",
        key: "Dinara",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "फारबिसगंज",
        key: "Forbesganj",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "गया शहर",
        key: "Gaya Town",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "घोसी",
        key: "Ghosi",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "गोविंदपुर",
        key: "Govindpur",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "गोह",
        key: "Goh",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "गोपालपुर",
        key: "Gopalpur",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "गोविंदगंज",
        key: "Govindganj",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "गुरुआ",
        key: "Gurua",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "हारलाखी",
        key: "Harlakhi",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "हरसिद्धि (एससी)",
        key: "Harsiddhi (SC)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "हिसुआ",
        key: "Hisua",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "इमामगंज (एससी)",
        key: "Imamganj (SC)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "जहानाबाद",
        key: "Jehanabad",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "जमुई",
        key: "Jamui",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "झाझा",
        key: "Jhajha",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "झंझारपुर",
        key: "Jhanjharpur",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "जोकीहाट",
        key: "Jokihat",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "कदवा",
        key: "Kadwa",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "कहलगांव",
        key: "Kahalgaon",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "कल्याणपुर",
        key: "Kalyanpur",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "काराकाट",
        key: "Karakat",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "करगहर",
        key: "Kargahar",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "कसबा",
        key: "Kasba",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "कटिहार",
        key: "Katihar",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "कटोरिया (एसटी)",
        key: "Katoria (ST)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "केसरिया",
        key: "Kesaria",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "खजौली",
        key: "Khajauli",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "किशनगंज",
        key: "Kishanganj",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "कोचाधामन",
        key: "Kochadhaman",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "कोढ़ा",
        key: "Kodha",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "कुर्था",
        key: "Kurtha",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "कुटुंबा (एससी)",
        key: "Kutumba (SC)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "लौकहा",
        key: "Laukaha",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "लौरिया",
        key: "Lauria",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "मधुबन",
        key: "Madhuban",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "मधुबनी",
        key: "Madhubani",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "मखदुमपुर (एससी)",
        key: "Makhdoompur (SC)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "मनिहारी (एसटी)",
        key: "Manihari (ST)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "मोहनिया (एससी)",
        key: "Mohania (SC)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "मोतिहारी",
        key: "Motihari",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "नबीनगर",
        key: "Nabinagar",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "नरकटिया",
        key: "Narkatia",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "नरकटियागंज",
        key: "Narkatiaganj",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "नरपतगंज",
        key: "Narpatganj",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "नाथनगर",
        key: "Nathnagar",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "नौतन",
        key: "Nautan",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "नवादा",
        key: "Nawada",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "निर्मली",
        key: "Nirmali",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "नोखा",
        key: "Nokha",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "ओबरा",
        key: "Obra",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "परिहार",
        key: "Parihar",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "फुलपरास",
        key: "Phulparas",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "पिपरा (पूर्वी चम्पारण)",
        key: "Pipra (Purvi Champaran)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "पिपरा (सुपौल)",
        key: "Pipra (Supaul)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "पीरपैंती (एससी)",
        key: "Pirpainti (SC)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "प्राणपुर",
        key: "Pranpur",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "पुर्णिया",
        key: "Purnia",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "रफीगंज",
        key: "Rafiganj",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "रजौली (एससी)",
        key: "Rajouli (SC)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "राजनगर (एससी)",
        key: "Rajnagar (SC)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "रामगढ़",
        key: "Ramgarh",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "रामनगर (एससी)",
        key: "Ramnagar (SC)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "रानीगंज (एससी)",
        key: "Raniganj (SC)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "रक्सौल",
        key: "Raxaul",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "रीगा",
        key: "Rega",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "रुन्नीसैदपुर",
        key: "Runnisaidpur",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "रुपौली",
        key: "Rupauli",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "सासाराम",
        key: "Sasaram",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "शिवहर",
        key: "Shivhar",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "शेरघाटी",
        key: "Sherghati",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "सिकंदरा (एससी)",
        key: "Sikandra (SC)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "सिकटा",
        key: "Sikta",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "सिकटी",
        key: "Sikti",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "सीतामढ़ी",
        key: "Sitamarhi",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "सुगौली",
        key: "Sugauli",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "सुल्तानगंज",
        key: "Sultanganj",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "सुपौल",
        key: "Supaul",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "सुरसंड",
        key: "Sursand",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "ठाकुरगंज",
        key: "Thakurganj",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "टिकारी",
        key: "Tikari",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "त्रिवेणीगंज (एससी)",
        key: "Triveniganj (SC)",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "वाल्मिकी नगर",
        key: "Valmiki Nagar",
        state: "बिहार",
        date: "11, Nov 2025",
      },
      {
        phase: "फेज 2",
        constituency: "वारसलीगंज (वारिसलीगंज)",
        key: "Warsaliganj",
        state: "बिहार",
        date: "11, Nov 2025",
      },
    ],
  };
  const [filtered, setFiltered] = useState([]);

  const handleConstitSearch = (q) => {
    const filtered1 =q&& phaseObj.phase1.filter((item) => {
      return (
        item.constituency.toLowerCase().startsWith(q.toLowerCase()) ||
        item.key.toLowerCase().startsWith(q.toLowerCase())
      );
    });
    const filtered2 =q&& phaseObj.phase2.filter((item) => {
      return (
        item.constituency.toLowerCase().startsWith(q.toLowerCase()) ||
        item.key.toLowerCase().startsWith(q.toLowerCase())
      );
    });

    setFiltered([...filtered1, ...filtered2]);
  };
  
  return (
    <div className="w-full my-2 ">
      {/* top table */}
      <div className="overflow-x-auto w-full whitespace-nowrap md:whitespace-normal">
        <table className="w-full">
          <thead>
            <tr className={`${isBH ? "bg-[#CF4C9B]" : "bg-[#EE3436]"}`}>
              <th className="align-top p-2 text-md  w-[10%] border border-black">
                चरण
              </th>
              <th className="align-top p-2 text-md  w-[10%] border border-black">
                सीटें
              </th>
              <th className="align-top p-2 text-md  w-[10%] border border-black">
                नोटिफिकेशन
              </th>
              <th className="align-top p-2 text-md  w-[15%] border border-black">
                नॉमिनेशन की अंतिम तारीख
              </th>
              <th className="align-top p-2 text-md  w-[15%] border border-black">
                नॉमिनेशन की जांच की अंतिम तारीख
              </th>
              <th className="align-top p-2 text-md  w-[15%] border border-black">
                नामांकन वापस लेन की अंतिम तारीख
              </th>
              <th className="align-top p-2 text-md  w-[10%] border border-black">
                मतदान
              </th>
              <th className="align-top p-2 text-md  w-[10%] border border-black">
                वोटों की गिनती
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="align-top p-2 text-md  border border-black">
                पहला चरण
              </td>
              <td className="align-top p-2 text-md  border border-black">
                121
              </td>
              <td className="align-top p-2 text-md  border border-black">
                10 अक्टूबर
              </td>
              <td className="align-top p-2 text-md  border border-black">
                17 अक्टूबर
              </td>
              <td className="align-top p-2 text-md  border border-black">
                18 अक्टूबर
              </td>
              <td className="align-top p-2 text-md  border border-black">
                20 अक्टूबर
              </td>
              <td className="align-top p-2 text-md  border border-black">
                6 नवंबर
              </td>
              <td className="align-top p-2 text-md  border border-black">
                14 नवंबर
              </td>
            </tr>
            <tr>
              <td className="align-top p-2 text-md  border border-black">
                दूसरा चरण
              </td>
              <td className="align-top p-2 text-md  border border-black">
                122
              </td>
              <td className="align-top p-2 text-md  border border-black">
                13 अक्टूबर
              </td>
              <td className="align-top p-2 text-md  border border-black">
                20 अक्टूबर
              </td>
              <td className="align-top p-2 text-md  border border-black">
                21 अक्टूबर
              </td>
              <td className="align-top p-2 text-md  border border-black">
                23 अक्टूबर
              </td>
              <td className="align-top p-2 text-md  border border-black">
                11 नवंबर
              </td>
              <td className="align-top p-2 text-md  border border-black">
                14 नवंबर
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* mid selection section  */}
      <div className="my-5 w-full flex flex-col jusitfy-center items-center">
        <div className="w-full md:w-[50%] flex justify-between mb-2">
          <div className="flex flex-col">
            <span className="text-sm text-[#4D4D4D]">मतगणना की तारीख</span>
            <span className="font-semibold">14-11-2025</span>
          </div>
          <div className="text-sm">
            <input
              checked={phase1 && phase2}
              type="checkbox"
              onChange={(e) => {
                if (!phase1 || !phase2) {
                  setPhase1(true);
                  setPhase2(true);
                } else {
                  setPhase1(false);
                  setPhase2(false);
                }
              }}
              className="accent-[#CF4C9B] mx-1"
            />
            <span className="-pt-2">Select All</span>
          </div>
        </div>

        <div className="  flex flex-row md:flex-row justify-between mb-4 gap-4 md:gap-2">
          <div className="flex gap-1 items-start bg-[#E6DA48] p-2 rounded-lg">
            <input
              checked={phase1}
              onChange={(e) => {
                if (!phase1) {
                  setPhase1(true);
                } else setPhase1(false);
              }}
              type="checkbox"
              className="accent-[#CF4C9B] mx-1 my-auto w-5 h-5"
            />
            <div className="flex flex-col px-2 border-r border-white">
              <span className="text-md md:text-lg font-semibold">फेज 1</span>
              <span className="text-sm md:text-md">06-11-25</span>
            </div>
            <div className="flex flex-col gap-1 px-2">
              <span className="text-md font-semibold border-b border-white">
                121 सीटें
              </span>
              <span className="text-sm">1 राज्य</span>
            </div>
          </div>
          <div className="flex gap-1 items-start bg-[#4B9DEB] p-2 rounded-lg">
            <input
              checked={phase2}
              onChange={(e) => {
                if (!phase2) {
                  setPhase2(true);
                } else setPhase2(false);
              }}
              type="checkbox"
              className="accent-[#CF4C9B] mx-1 my-auto w-5 h-5"
            />
            <div className="flex flex-col px-2 border-r border-white">
              <span className="text-md md:text-lg font-semibold">फेज 2</span>
              <span className="text-sm md:text-md">11-11-25</span>
            </div>
            <div className="flex flex-col gap-1 px-2">
              <span className="text-md font-semibold border-b border-white">
                122 सीटें
              </span>
              <span className="text-sm">1 राज्य</span>
            </div>
          </div>
        </div>
        <div className="w-full md:w-[60%] flex gap-1">
          <div className="w-[45%] h-0 border-b my-auto  border-[#E9E9E9]"></div>
          <span className="rounded-full bg-[#E9E9E9] text-sm w-8 h-8 flex justify-center items-center font-semibold">
            OR
          </span>
          <div className="w-[45%] h-0 border-b my-auto border-[#E9E9E9]"></div>
        </div>
        <div className="w-full md:w-[60%]">
          <input
            type="text"
            placeholder="निर्वाचन क्षेत्र चुनें"
            className="w-full rounded-lg p-2 border border-black text-sm my-4"
            onChange={(e) => {
              handleConstitSearch(e.target.value);
            }}
          />
        </div>
      </div>

      <div className="overflow-x-auto w-full whitespace-nowrap md:whitespace-normal">
      <table className="border border-separate border-spacing-0 overflow-hidden border-white rounded-md">
        <thead>
          <tr
            className={`${isBH ? "bg-[#CF4C9B]" : "bg-[#EE3436]"} rounded-t-lg`}
          >
            <th className="text-sm font-semibold">फेज</th>
            <th className="text-sm font-semibold">विधान सभा सीट का नाम</th>
            <th className="text-sm font-semibold">राज्य का नाम</th>
            <th className="text-sm font-semibold">मतदान की तारीख</th>
          </tr>
        </thead>
        <tbody>
          {filtered.length > 0 ? (
            <>
              {filtered?.map((item, index) => {
                return (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? "bg-white" : "bg-gray-100"
                    }`}
                  >
                    <td
                      className={`text-sm text-center ${
                        item.phase == "फेज 1" ? "bg-[#E6DA48]" : "bg-[#4B9DEB]"
                      }`}
                    >
                      {item.phase}
                    </td>
                    <td className="text-sm text-center">{item.constituency}</td>
                    <td className="text-sm text-center">{item.state}</td>
                    <td className="text-sm text-center">{item.date}</td>
                  </tr>
                );
              })}
            </>
          ) : (
            <>
              {phase1 &&
                phaseObj.phase1?.map((item, index) => {
                  return (
                    <tr
                      key={index}
                      className={`${
                        index % 2 === 0 ? "bg-white" : "bg-gray-100"
                      }`}
                    >
                      <td className="text-sm text-center bg-[#E6DA48]">
                        {item.phase}
                      </td>
                      <td className="text-sm text-center">
                        {item.constituency}
                      </td>
                      <td className="text-sm text-center">{item.state}</td>
                      <td className="text-sm text-center">{item.date}</td>
                    </tr>
                  );
                })}
              {phase2 &&
                phaseObj.phase2?.map((item, index) => {
                  return (
                    <tr
                      key={index}
                      className={`${
                        index % 2 === 0 ? "bg-white" : "bg-gray-100"
                      }`}
                    >
                      <td className="text-sm text-center bg-[#4B9DEB]">
                        {item.phase}
                      </td>
                      <td className="text-sm text-center">
                        {item.constituency}
                      </td>
                      <td className="text-sm text-center">{item.state}</td>
                      <td className="text-sm text-center">{item.date}</td>
                    </tr>
                  );
                })}
            </>
          )}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default ElectionSchedule;
